/* eslint-disable */

import { findLiaison } from './query-liaison.js';

export default () => {
    const form = document.querySelector('form');
    const liaisonFilter = document.getElementById('liaisonFilter');
    const validator = require('@klickinc/util-validator');

    const addErrorClasses = (errorDiv) => {
        document.querySelector('#form-error').classList.add('active');
        errorDiv.classList.add('active');
        if ( errorDiv == document.getElementById('zipCode-error')) {
            errorDiv.classList.add('active');
            errorDiv.parentElement.classList.add('active-error');
        }
        errorDiv.parentElement.classList.add('active-error');
        if ( errorDiv.parentElement.matches('.form-control-radio') ){
            document.querySelectorAll('.form-control-radio').forEach(input => {
                input.classList.add('active-error');
            });
        }
        if(document.querySelectorAll('.form-control.active-error').length > 0) {
            document.querySelectorAll('.form-control.active-error').forEach(f => {
                if(f.querySelector('input').type !== 'radio') {
                    f.querySelector('input').setAttribute('aria-invalid', 'true');
                    f.querySelector('input').setAttribute('aria-labelledby', f.querySelector('.error.specific-error').id);
                }
            })
        }
        document.querySelectorAll('form .error.specific-error.active')[0].focus();
    }

    const removeErrorClasses = (errorDiv) => {
        errorDiv.classList.remove('active');
        errorDiv.parentElement.classList.remove('active-error');
        if ( errorDiv == document.getElementById('zipCode-error')) {
            errorDiv.classList.remove('active');
            errorDiv.parentElement.classList.remove('active-error');
        }
        if ( errorDiv.parentElement.matches('.form-control-radio') ){
            document.querySelectorAll('.form-control-radio').forEach(input => {
                input.classList.remove('active-error');
            });
        }

        if(document.querySelectorAll('.error.specific-error.active').length === 0) {
            document.querySelector('#form-error').classList.remove('active');
        }
        if(document.querySelectorAll('.form-control:not(.active-error)').length > 0) {
            document.querySelectorAll('.form-control:not(.active-error)').forEach(f => {
                f.querySelector('input').removeAttribute('aria-invalid');
                f.querySelector('input').removeAttribute('aria-labelledby');
            })
        }
    }

    const errors = (els, err) => {
        return [...els].reduce((e, f) => {
            const errorDiv = document.getElementById(f.name + '-error');
            return errorDiv && (err[f.name] ? addErrorClasses(errorDiv) : removeErrorClasses(errorDiv) ) || e;
        }, false);
    };

    const validateField = rules => ({ target: e }) => errors([e], validator(rules, {
        __fields: [e.name],
        [e.name]: e.type === 'select-multiple' ? e.value : e.value
    }));

    const validateForm = (rules) => {

        return (e) => {
            document.querySelector('.medical-liaison').hidden = true;
            document.querySelector('.medical-liaison--no-results').hidden = true;
            
            let formData = [];
            errors(e.preventDefault() || e.target.elements, validator(rules, JSON.stringify(
                formData = [...new FormData(e.target)].reduce((data, [name, value]) => {
                    const formEl = e.target.elements[name];
                    data[name] = formEl.type === 'select' ? formEl.selectedOptions : value;
                    return data;
                }, {})
            )));
            const err = validator(rules, formData);
            if (Object.keys(err).length < 1) {
                findLiaison(formData.zipCode, formData.localLiaison);
                document.querySelector('form[data-loading="false"]').setAttribute('data-loading', 'true');
            }
        };
    };

    const validate = (form, rules) => {
        if (!form) { return; }
        const field = validateField(rules);
        const submit = validateForm(rules);
        //form.addEventListener('input', field);
        liaisonFilter && liaisonFilter.addEventListener('submit', submit);
    };

    const ruleSet = require('./ruleSet.js');

    if (liaisonFilter) {
        validate(liaisonFilter, ruleSet.liaisonFilter.rules);
    }

};
